import { FunctionComponent, useEffect } from "react";
import CatalogArea from "../../CatalogArea";
import Footer from "../../Footer";
import TextSection from "../TextSection";
import "./styles.scss";
import TopShadow from "../../common/TopShadow";
import { ScrollToTopOnMount } from "../../common/ScrollToTopOnMount";
import HomeVideo from "../../HomeVideo";

const AboutUsContainer: FunctionComponent = ({}) => {
  const sections = [
    {
      title: "Alta tecnología",
      description:
        "ofrecemos la posibilidad de personalizar cada cadena, ajustándola a las medidas y preferencias de cada cliente. Con nuestra tecnología avanzada, podemos producir cadenas de cualquier tamaño y estilo, desde las más delicadas hasta las más robustas.",
    },
    {
      title: "Tradición y vanguardia",
      description:
        "Nos especializamos en la producción de joyas personalizadas, adaptándonos a las necesidades y gustos de cada cliente. Nuestro equipo de diseñadores y artesanos altamente capacitados trabajan juntos para crear piezas únicas y exclusivas que reflejen la personalidad y estilo de cada cliente.",
    },
  ];
  return (
    <>
      <ScrollToTopOnMount />
      <section className="about-us">
        <TopShadow />
        <div className="about-us__history">
          <h2>Nuestra Historia</h2>
          <p>
            Rtabak es una empresa familiar ligada al sector desde la década del
            50. Nos hemos propuesto a través de los años mejorar la calidad de
            nuestros productos manteniendo siempre el titulo garantizado en Oro
            18k y Plata 925
          </p>
        </div>
        <div className="about-us__subcontainer">
          {sections.map((section, index) => (
            <TextSection
              title={section.title}
              description={section.description}
              key={index}
            />
          ))}
        </div>
      </section>
      <HomeVideo />
      <CatalogArea />
      <Footer />
    </>
  );
};

export default AboutUsContainer;
